import EventsScreen from './EventsScreen';

export default EventsScreen;
